export default {
    Chart: 'Chart',
    SaveAsImage: 'Save as image',
    Table: 'Table',
    LineGraph: 'Line graph',
    BarGraph: 'Bar graph',
    PieChart: 'Pie chart',
    Percentage: 'Percentage ',
    ClearMemory: 'Clear memory',
    ChatContextClearedSuccessfully: 'Chat context cleared successfully',
    FileUploadFailed: 'File upload failed',
    ImageUploadGailed: 'Image upload failed',
    PleaseEnterTheChatContentPressShiftEnterToTtartANewLine: 'Sending message ... Shift+Enter to break line',
    EnterMessage: 'Please enter message',
    PleaseEnterTheChatContent: 'Enter chat content.',
    KnowledgeBaseSource: 'Knowledge base source:',
    DrawingInProgress: 'Drawing in progress...',
    DatabaseExecution: 'Database execution',
    CopyCode: 'Copy code',
    CopySuccessful: 'Copy successful',
    LongPressOnTheImageToSave: 'Long press on the image to save',
    TextCopy: 'Copy text',
    VoiceRead: 'Speech read',
    PausePlayback: 'Pause playback',
    IHeFoundTheAnswerForYou: 'I have found the answer for you.',
    ExecutionSuccessful: 'Success',
    ExecutionFailed: 'Execution failed.',
    RunningParameters: 'Running parameters.',
    RunningResults: 'Results',
    ReferencesFromSources: 'References from 10 sources.',
    PlaybackFailed: 'Playback failed.',
}
